import { isEmptyObject } from "jquery";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AddDataseRoute,
  cleanDatasetElements,
  fetchDatasets,
  updateDatasetRoute,
} from "../actions/datasetAction";
import { resourceSelectedByUser } from "../actions/resourcesAction";
import { RootState } from "../store/store";
import { Resource } from "../types/resourceType";

const useDatasetContainer = (id?: string) => {
  const dispatch = useDispatch();
  const resourcesState = useSelector((state: RootState) => state.resources);
  const datasetState = useSelector((state: RootState) => state.datasets);
  const [currentPath, setCurrentPath] = useState("");
  const tableReference = useRef<HTMLInputElement>(null);
  const [searchText, setSearchText] = useState("");
  const pageSize = 20;

  const handleOnClick = (
    folderName: string,
    path: string,
    searchText?: string | undefined
  ) => {
    setSearchText("");
    dispatch(cleanDatasetElements());
    const fullPath = path !== "" ? `${path}/${folderName}` : folderName;
    dispatch(fetchDatasets(id, fullPath, pageSize));
    setCurrentPath(fullPath);
    addDatasetSelected(folderName, fullPath);
  };

  const addDatasetSelected = (folderName: string, path: string) => {
    //find any element in datasetState.datasetsLocation
    const elementExist = datasetExistOnRoutes(folderName, path);
    //if element exist
    if (!elementExist) {
      dispatch(AddDataseRoute({ path: path, name: folderName }));
    }
  };

  const datasetExistOnRoutes = (folderName: string, path: string) => {
    return datasetState.datasetRoutes.some(
      (item: any) => item.name === folderName && item.path === path
    );
  };

  const handleOnClickBreadcrumb = (path: string) => {
    setSearchText("");
    dispatch(cleanDatasetElements());
    dispatch(fetchDatasets(id, path, pageSize));
    const idx = datasetState.datasetRoutes.findIndex(
      (item: any) => item.path === path
    );
    const newDatasetRoutes = datasetState.datasetRoutes.slice(0, idx + 1);
    dispatch(updateDatasetRoute(newDatasetRoutes));
    setCurrentPath(path);
  };

  const loadMoreOnClick = () => {
    dispatch(
      fetchDatasets(
        id,
        currentPath,
        pageSize,
        datasetState?.datasets?.data?.marker
      )
    );
  };

  const onSearch = (text: string) => {
    if (!datasetState?.datasets?.loading) {
      setSearchText(text);
      dispatch(cleanDatasetElements());
      dispatch(fetchDatasets(id, currentPath, pageSize, "", text));
    }
  };

  useEffect(() => {
    const dataset = resourcesState.resources.data?.find(
      (item: Resource) => item.id === id
    );
    dispatch(
      resourceSelectedByUser(dataset?.id, dataset?.displayName, dataset?.type)
    );
    setSearchText("");
  }, [dispatch, id, resourcesState.resources.data]);

  useEffect(() => {
    //loads the datasets selected by the user.
    if (!isEmptyObject(id) && !isEmptyObject(resourcesState.resources.data)) {
      dispatch(fetchDatasets(id, null, pageSize));
      setCurrentPath("");
      setSearchText("");
    }
  }, [dispatch, id, resourcesState.resources.data]);

  useEffect(() => {
    //Add path when typed in browser.
    if (resourcesState.resourceSelected.name) {
      if (datasetState.datasetRoutes.length === 0) {
        dispatch(
          AddDataseRoute({
            path: "",
            name: resourcesState.resourceSelected.name,
          })
        );
      }
    }
  }, [
    dispatch,
    datasetState.datasetRoutes,
    resourcesState.resourceSelected.name,
  ]);

  return {
    datasetState,
    resourcesState,
    handleOnClick,
    handleOnClickBreadcrumb,
    currentPath,
    loadMoreOnClick,
    tableReference,
    onSearch,
    searchText,
    setSearchText,
    pageSize
  };
};
export default useDatasetContainer;
